import React, { useContext, useState, useEffect } from 'react';
import { SubjectsContext } from "./SubjectsContext";
import {MDBBtn, MDBIcon} from "mdb-react-ui-kit";

const SubjectSelect = ({ value, onCancel }) => {
    const { subjects, onSave } = useContext(SubjectsContext);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [groupedSubjects, setGroupedSubjects] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});

    const findSubjectId = (top, subject) => {
        if (!subjects || !subjects.length) return null;

        const foundSubject = subjects.find(item =>
            item.top === top && item.subject === subject
        );

        return foundSubject ? foundSubject.id : null;
    };

    useEffect(() => {
        if (value) {
            const parsedValues = [];
            const pairs = value.split(';').map(item => item.trim()).filter(Boolean);

            pairs.forEach(pair => {
                if (pair.startsWith('-')) {
                    const subject = pair.substring(1);
                    const id = findSubjectId("", subject);
                    parsedValues.push({
                        id,
                        top: "",
                        subject: subject
                    });
                } else if (pair.includes('-')) {
                    const [topCategory, subject] = pair.split('-');
                    const id = findSubjectId(topCategory, subject);
                    parsedValues.push({
                        id,
                        top: topCategory,
                        subject: subject
                    });
                } else {
                    const id = findSubjectId("", pair);
                    parsedValues.push({
                        id,
                        top: "",
                        subject: pair
                    });
                }
            });

            setSelectedSubjects(parsedValues);
        }
    }, [value, subjects]);

    useEffect(() => {
        if (subjects && subjects.length) {
            const grouped = subjects.reduce((acc, curr) => {
                const topCategory = curr.top || "No category";
                if (!acc[topCategory]) {
                    acc[topCategory] = [];
                }
                acc[topCategory].push(curr);
                return acc;
            }, {});

            setGroupedSubjects(grouped);

            const initialExpandedState = {};
            Object.keys(grouped).forEach(category => {
                initialExpandedState[category] = false;
            });
            setExpandedGroups(initialExpandedState);
        }
    }, [subjects]);

    const isSelected = (topCategory, subjectName) => {
        return selectedSubjects.some(item => {
            const itemTop = item.top || "No category";
            return itemTop === topCategory && item.subject === subjectName;
        });
    };

    const handleCheckboxChange = (topCategory, subjectItem) => {
        const normalizedTop = topCategory || "No category";
        let newSelected = [...selectedSubjects];
        const exists = isSelected(normalizedTop, subjectItem.subject);

        if (exists) {
            newSelected = newSelected.filter(item => {
                const itemTop = item.top || "No category";
                return !(itemTop === normalizedTop && item.subject === subjectItem.subject);
            });
        } else {
            newSelected.push({
                id: subjectItem.id,
                top: normalizedTop,
                subject: subjectItem.subject
            });
        }

        setSelectedSubjects(newSelected);
    };

    const toggleGroup = (category) => {
        setExpandedGroups(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const handleSave = () => {
        onSave(selectedSubjects);
    };

    const handleCancel = () => {
        onCancel();
    };


    return (
        <div className="p-2">
            {Object.entries(groupedSubjects).map(([topCategory, items], index) => (
                <div key={index} className="mb-1">
                    <div
                        onClick={() => toggleGroup(topCategory)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            padding: '4px 0'
                        }}
                    >
                        <MDBIcon
                            fas
                            icon={expandedGroups[topCategory] ? 'chevron-down' : 'chevron-right'}
                            className="me-2"
                            size='md'
                        />
                        {topCategory} ({items.length})
                    </div>

                    {expandedGroups[topCategory] && (
                        <div className={'ms-4'}>
                            {items.map((item) => (
                                <div key={item.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`checkbox-${item.id}`}
                                        checked={isSelected(topCategory, item.subject)}
                                        onChange={() => handleCheckboxChange(topCategory, item)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`checkbox-${item.id}`}
                                    >
                                        {item.subject}
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
            <MDBBtn
                className={'me-2 mt-3 btn-sm'}
                onClick={handleSave}
            >
                Save
            </MDBBtn>
            <MDBBtn
                className={'btn-sm'}
                outline={true}
                onClick={handleCancel}
            >
                Cancel
            </MDBBtn>
        </div>
    );
};

export default SubjectSelect;
